import releaseSettings from "../../../config/releaseSettings";

const getKey = (base, key) => {
    if (base[key]) {
        return base[key];
    } else {
        return key;
    }
};
const extendedBase = (base) => (
{
    ...base,
    Var_Header:                                 getKey(base,"ElT_Header"),
    Var_Banner:                                 getKey(base,"ElT_Banner"),
    Var_Newsletter:                             getKey(base,"ElT_Newsletter"),
    Var_Footer:                                 getKey(base,"ElT_Footer"),
    Var_Product:                                getKey(base,"ElT_Product"),
    Clv_RibbonNewProductColor:                  getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_NewProduct"),
    Clv_RibbonPromotionColor:                   getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_Promotion"),
    Clv_RibbonRecommendedProductColor:          getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_RecomendedProducts"),
    Clv_RibbonExtraPriceColor:                  getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_ProductExtraPrice"),
    Clv_RibbonExtraQualityColor:                getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_ProductExtraQuality"),
    Clv_RibbonNewsletterProductColor:           getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_ProductFromNewsletter"),
    Clv_RibbonSellerRecommendationColor:        getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_ProductSellerRecommended"),
    Clv_RibbonRewardColor:                      getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_Reward"),
    Clv_RibbonBestReviewsColor:                 getKey(base,"BackgroundColor") + " - " + getKey(base,"Rec_BestRated"),
    Clv_CheckBgColor:                           getKey(base,"BackgroundColor"),
    Clv_BreadcrumbsBgColor:                     getKey(base,"BackgroundColor"),
    Clv_PrimaryBtnBgColor:                      getKey(base,"BackgroundColor"),
    Clv_SliderBgColor:                          getKey(base,"BackgroundColor"),
    Clv_PaginationBgColor:                      getKey(base,"BackgroundColor"),
    Clv_PageBgColor:                            getKey(base,"BackgroundColor"),
    Clv_HeaderBgColor:                          getKey(base,"BackgroundColor"),
    Clv_FooterBgColor:                          getKey(base,"BackgroundColor"),
    Clv_CopyrightBgColor:                       getKey(base,"BackgroundColor"),
    Clv_InputNewsletterBgColor:                 getKey(base,"BackgroundColor"),
    Clv_BreadcrumbsFontColor:                   getKey(base,"FontColor"),
    Clv_InputNewsletterFontColor:               getKey(base,"FontColor"),
    Clv_PrimaryBtnFontColor:                    getKey(base,"FontColor"),
    Clv_IconBtnFontColor:                       getKey(base,"FontColor"),
    Clv_RibbonFontColor:                        getKey(base,"FontColor"),
    Clv_PaginationFontColor:                    getKey(base,"FontColor"),
    Clv_PrimaryBtnBorderColor:                  getKey(base,"BorderColor"),
    Clv_PaginationBorderColor:                  getKey(base,"BorderColor"),
    Clv_InputNewsletterBorderColor:             getKey(base,"BorderColor"),
    Clv_IconBtnIconColor:                       getKey(base,"IconColor"),
    Clv_SliderArrowColor:                       getKey(base,"ArrowColor"),
    Clv_PrimaryBtnHoverBgColor:                 getKey(base,"Hover") + " - " + getKey(base,"BackgroundColor"),
    Clv_SliderHoverBgColor:                     getKey(base,"Hover") + " - " + getKey(base,"BackgroundColor"),
    Clv_PaginationHoverBgColor:                 getKey(base,"Hover") + " - " + getKey(base,"BackgroundColor"),
    Clv_PrimaryBtnHoverBorderColor:             getKey(base,"Hover") + " - " + getKey(base,"BorderColor"),
    Clv_PaginationHoverBorderColor:             getKey(base,"Hover") + " - " + getKey(base,"BorderColor"),
    Clv_IconBtnHoverIconColor:                  getKey(base,"Hover") + " - " + getKey(base,"IconColor"),
    Clv_SliderHoverArrowColor:                  getKey(base,"Hover") + " - " + getKey(base,"ArrowColor"),
    Clv_IconBtnHoverFontColor:                  getKey(base,"Hover") + " - " + getKey(base,"FontColor"),
    Clv_PrimaryBtnHoverFontColor:               getKey(base,"Hover") + " - " + getKey(base,"FontColor"),
    Clv_PaginationHoverFontColor:               getKey(base,"Hover") + " - " + getKey(base,"FontColor"),
    Clv_PaginationActiveBgColor:                getKey(base,"ActivePage") + " - " + getKey(base,"BackgroundColor"),
    Clv_PaginationActiveFontColor:              getKey(base,"ActivePage") + " - " + getKey(base,"FontColor"),
    Clv_PaginationActiveBorderColor:            getKey(base,"ActivePage") + " - " + getKey(base,"BorderColor"),
}
)

export function getTranslationObject(lang) {
    if(!lang || typeof lang !== "string"){
        throw new Error("lang not found");
    }

    const plDefault = {...require('./preview/pl.json') , ...require(`./pl.json`)};
    let base = {};
    try {
    base = {...require(`./preview/${lang}.json`),...require(`./${lang}.json`)};
    } catch (e) {
        console.error(`${`translations/preview/${lang}.json`} or ${`translations/${lang}.json`} were not found, please check translations`);
    }
    let baseWithPlaceholders;
    if (releaseSettings.polishPlaceholders) {
        baseWithPlaceholders = {...plDefault, ...base};
    } else {
        baseWithPlaceholders = base;
    }
    return extendedBase(baseWithPlaceholders);
}